import { render, staticRenderFns } from "./DenseToggleButton.vue?vue&type=template&id=c2be9436&scoped=true&"
import script from "./DenseToggleButton.vue?vue&type=script&lang=js&"
export * from "./DenseToggleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2be9436",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VBtnToggle,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2be9436')) {
      api.createRecord('c2be9436', component.options)
    } else {
      api.reload('c2be9436', component.options)
    }
    module.hot.accept("./DenseToggleButton.vue?vue&type=template&id=c2be9436&scoped=true&", function () {
      api.rerender('c2be9436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DenseToggleButton.vue"
export default component.exports